import React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

export const ImageContainer = styled.div``;
const success = process.env.PUBLIC_URL + "/images/happyBeanie.png";
const error = process.env.PUBLIC_URL + "/images/errorBeanie.png";

export function ToastSuccess(message) {
  toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
}

export function ToastError(message) {
  toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 5000 });
}

export const ToastGenericError = () => {
  // eslint-disable-next-line new-cap
  ToastError("An error occurred!");
};

export function ToastSuccessFun(message) {
  const formattedMessage = (<ImageContainer>
    <img src={success} style={{ height: "50px" }} />
    {message}
  </ImageContainer>);
  toast.success(formattedMessage, { position: toast.POSITION.BOTTOM_RIGHT });
}

export function ToastErrorFun(message) {
  const formattedMessage = (<ImageContainer>
    <img src={error} style={{ height: "50px" }} />
    {message}
  </ImageContainer>);
  toast.error(formattedMessage, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 5000 });
}

export function ToastInfo(message) {
  toast.info(message, { position: toast.POSITION.BOTTOM_RIGHT });
}
